import React from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import CssBaseline from "@material-ui/core/CssBaseline";

interface IProps {
	children?: React.ReactNode;
}

const useStyles = makeStyles(
	({ spacing, palette }: Theme) => ({
		root: {
			width: "100vw",
			height: "100vh",
			backgroundColor: palette.primary.main
		},
		header: {
			paddingTop: spacing(8),
			paddingBottom: spacing(8),
			textAlign: "center"
		},
		title: {
			fontWeight: 900,
			color: "#fff"
		},
		subTitle: {
			fontWeight: 300,
			color: "#fff",
			textTransform: "capitalize"
		}
	}),
	{ name: "UnauthorizedLayout" }
);

export default function UnauthorizedLayout(props: IProps) {
	const classes = useStyles();
	
	return (
		<main className={classes.root}>
			<CssBaseline />
			<header className={classes.header}>
				<Typography variant="h2" className={classes.title}>REG</Typography>
				<Typography variant="h5" className={classes.subTitle}>Login page</Typography>
				{process.env.NODE_ENV === "development" && (
					<Typography variant="h5" className={classes.subTitle}>
						{process.env.REACT_APP_DEPLOY_VERSION}
					</Typography>
				)}
			</header>
			{props.children}
		</main>
	);
}
